// eslint-disable-next-line import/no-extraneous-dependencies
import { StyleSheet, Font } from "@react-pdf/renderer";
// @ts-ignore
import Arial from "../../../assets/fonts/ARIAL.TTF";
// @ts-ignore
import ArialItalic from "../../../assets/fonts/ARIALI 1.TTF";

// Font.register({
//   family: "Arial",
//   format: "truetype",
//   fonts: [{ src: Arial }, { src: ArialItalic, fontStyle: "italic" }],
// });

export const styles: any = StyleSheet.create({
  topView: {
    position: "relative",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba( 0, 0, 0, 0.5 )",
  },
  tdcImage: {
    position: "absolute",
    top: "25%",
    left: "25px",
    height: "50%",
  },
  topTextWrapper: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-30%)",
    right: "25px",
  },
  topText: {
    width: "200px",
    color: "white",
    textAlign: "right",
    // fontFamily: "Arial",
    fontSize: "24px",
    fontStyle: "italic",
  },
  gold: {
    width: "100%",
    backgroundColor: "#A18557",
    padding: "10px 10% 12px",
  },
  goldText: {
    // fontFamily: "Arial",
    fontSize: "11px",
    color: "white",
    textAlign: "center",
    marginBottom: "1px",
  },
  goldLarge: {
    // fontFamily: "Arial",
    fontSize: "14px",
    color: "white",
    textAlign: "center",
    marginTop: "4px",
  },
  prosWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    flexDirection: "row",
    gap: "0",
    padding: "15px",
  },
  pro: {
    color: "black",
    width: "50%",
    minHeight: "100px",
    padding: "10px 15px 10px 10px",
    display: "flex",
    flexDirection: "column",
    height: "165px",
  },
  proTopWrapper: {
    display: "flex",
    flexDirection: "row",
  },
  proAvatarWrapper: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    overflow: 'hidden',
    zIndex: "1",
    flexShrink: 0,
    flexGrow: 1,
  },
  proAvatar: {
    height: '50px',
    maxWidth: '50px',
  },
  proDeets: {
    width: "80%",
    padding: "0 10px",
  },
  proName: {
    fontSize: "16px",
    textTransform: "uppercase",
    margin: "0",
    maxHeight: "30px",
  },
  proProfession: {
    fontSize: "10px",
    margin: "0",
    marginTop: "4px",
  },
  proSocial: {
    display: "flex",
    flexDirection: "row",
    marginTop: "6px",
    gap: "10px",
  },
  proBio: {
    fontSize: "12px",
    paddingTop: "10px",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  bottomSection: {
    height: "120px",
    backgroundColor: "black",
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    width: "100%",
    overflow: "hidden",
  },
  bottomTile: {
    position: "absolute",
    minWidth: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    margin: "auto",
    marginLeft: "-30px",
  },
  tileItem: {
    // display: "inline-",
    height: "100%",
    width: "auto",
  },
  bottomTextWrapper: {
    position: "absolute",
    left: "0",
    right: "0",
    top: "35px",
    display: "flex",
    justifyContent: "center",
  },
  bottomText1: {
    color: "white",
    textAlign: "center",
    fontSize: "16px",
  },
  bottomText2: {
    color: "white",
    textAlign: "center",
    marginTop: "5px",
  },
});

export const wideStyles: any = StyleSheet.create({
  pro: {
    height: "240px",
  },
  proAvatar: {
    width: "70px",
    height: "70px",
  },
  proProfession: {
    marginTop: "9px",
  },
  proSocial: {
    marginTop: "11px",
  }
});
